import { UserProfile, UserRole } from "../../../../types/userProfile";
import type { DetailsSheetViewModel } from "../types";
import { buildFacts } from "../checks/buildFacts";
import { dialogButtonsForRole } from "../rules/dialogButtonsForRole";
import { mapVariantToBaseVM } from "./mapVariantToBaseVM";
import { resolveDetailsSheetVariant } from "../rules/resolverVariant";
import { canShowOuterDeactivate } from "../rules/canShowOuterDeactivate";
import { canShowInnerDeactivate } from "../rules/canShowInnerDeactivate";
/**
 * Builds the full Details Sheet View Model from currentUser + details.
 */
export function buildViewModel(
  currentUser: Pick<UserProfile, "role" | "userDisplayName">,
  details: TranslationDetail
): DetailsSheetViewModel {
  const facts = buildFacts(currentUser, details);
  const variant = resolveDetailsSheetVariant(
    { role: facts.role, userDisplayName: currentUser.userDisplayName },
    details
  );
  const base = mapVariantToBaseVM(variant);
  const dialogButtons = dialogButtonsForRole(facts.role);

  if (facts.isApproved) {
    base.pendingCard.visible = false;
    base.pendingCard.showsApproveDecline = false;
    base.editIconVisible = true;
  } else {
    base.pendingCard.visible = true;
    base.pendingCard.showsApproveDecline = facts.role === UserRole.Admin;
    base.editIconVisible = false;
  }

  return {
    ...base,
    dialogButtons,
    outerDeactivateVisible: canShowOuterDeactivate(facts),
    pendingCard: {
      ...base.pendingCard,
      showsDeactivateInsideCard: canShowInnerDeactivate(facts),
    },
  };
}
